import { makeStyles } from '@surveycake/rc';

export const useStyles = makeStyles([
  [
    'button',
    (theme, [color, size]) => [
	  `
			:lang(ar) {
				transform: scaleX(-1);
				direction: rtl;
			}
			display: inline-block;
			color: ${theme.color.text.white};
			line-height: 1.5;
			border-radius: 4px;
			border: 0;
			box-shadow: none;
			text-align: center;
			text-shadow: none;
			transition: background-color 0.3s ease, opacity 0.3s ease;
			outline: none;
			box-sizing: border-box;
			cursor: pointer;

			&:disabled {
				cursor: not-allowed;
			}

			& span + svg,
			& svg + span {
				margin-left: 8px;
			}
		`,
      !color &&
        `
			background-color: ${theme.color.text.B3};

			&:hover:not(:disabled) {
				background-color: ${theme.color.text.B4};
			}

			&:disabled {
				background-color: ${theme.color.text.B2};
			}
		`,
      color === 'primary' &&
        `
			background-color: ${theme.color.primary.default};

			&:hover:not(:disabled) {
				background-color: ${theme.color.primary.active};
			}

			&:disabled {
				background-color: ${theme.color.primary.disabled};
			}
		`,
      size === 'medium' &&
        `
			font-size: 16px;
			padding: 8px 12px;
		`,
      size === 'large' &&
        `
			font-size: 24px;
			padding: 12px 16px;
		`
    ]
  ]
]);
